import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("Lucy")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Lucy")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("未审核")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("已审核")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("未通过审核")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("上架")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("下架")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("是")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("否")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("是")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("否")
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" - ")
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" - ")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("上架")
const _hoisted_15 = /*#__PURE__*/_createTextVNode("下架")
const _hoisted_16 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_17 = /*#__PURE__*/_createTextVNode("筛选")
const _hoisted_18 = /*#__PURE__*/_createTextVNode("重置")
const _hoisted_19 = /*#__PURE__*/_createTextVNode("全新（车辆/机械）")
const _hoisted_20 = /*#__PURE__*/_createTextVNode("二手（车辆/机械）")
const _hoisted_21 = /*#__PURE__*/_createTextVNode("全新五金与建材")
const _hoisted_22 = /*#__PURE__*/_createTextVNode("工程机械与配件")
const _hoisted_23 = /*#__PURE__*/_createTextVNode("工程车辆配件")
const _hoisted_24 = /*#__PURE__*/_createTextVNode(" 发布商品")
const _hoisted_25 = { key: 0 }
const _hoisted_26 = /*#__PURE__*/_createTextVNode("删除")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_checkbox_group = _resolveComponent("a-checkbox-group")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_a_menu = _resolveComponent("a-menu")!
  const _component_DownOutlined = _resolveComponent("DownOutlined")!
  const _component_a_dropdown = _resolveComponent("a-dropdown")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_table = _resolveComponent("a-table")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_card, null, {
      default: _withCtx(() => [
        _createVNode(_component_a_form, {
          ref: "formRef",
          name: "advanced_search",
          class: "ant-advanced-search-form",
          model: _ctx.formState
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_row, { gutter: 24 }, {
              default: _withCtx(() => [
                _createVNode(_component_a_col, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, { label: "商品名称" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input, {
                          placeholder: "商品名称",
                          style: {"width":"300px"}
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, { label: "商品类目" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_select, {
                          placeholder: "商品类目",
                          style: {"width":"300px"}
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_select_option, { value: "lucy" }, {
                              default: _withCtx(() => [
                                _hoisted_1
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, { label: "商品品牌" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_select, {
                          placeholder: "商品品牌",
                          style: {"width":"300px"}
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_select_option, { value: "lucy" }, {
                              default: _withCtx(() => [
                                _hoisted_2
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, { label: "审核状态" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_select, {
                          placeholder: "审核状态",
                          style: {"width":"300px"}
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_select_option, { value: "1" }, {
                              default: _withCtx(() => [
                                _hoisted_3
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_a_select_option, { value: "2" }, {
                              default: _withCtx(() => [
                                _hoisted_4
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_a_select_option, { value: "3" }, {
                              default: _withCtx(() => [
                                _hoisted_5
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, { label: "上架状态" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_select, {
                          placeholder: "上架状态",
                          style: {"width":"300px"}
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_select_option, { value: "1" }, {
                              default: _withCtx(() => [
                                _hoisted_6
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_a_select_option, { value: "2" }, {
                              default: _withCtx(() => [
                                _hoisted_7
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, { label: "是否团采" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_select, {
                          placeholder: "是否团采",
                          style: {"width":"300px"}
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_select_option, { value: "1" }, {
                              default: _withCtx(() => [
                                _hoisted_8
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_a_select_option, { value: "2" }, {
                              default: _withCtx(() => [
                                _hoisted_9
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, { label: "是否推荐" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_select, {
                          placeholder: "是否推荐",
                          style: {"width":"300px"}
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_select_option, { value: "1" }, {
                              default: _withCtx(() => [
                                _hoisted_10
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_a_select_option, { value: "2" }, {
                              default: _withCtx(() => [
                                _hoisted_11
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, { label: "商品价格" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input, {
                          placeholder: "最低价格",
                          style: {"width":"144px"}
                        }),
                        _hoisted_12,
                        _createVNode(_component_a_input, {
                          placeholder: "最高价格",
                          style: {"width":"144px"}
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, { label: "商品销量" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input, {
                          placeholder: "最低销量",
                          style: {"width":"144px"}
                        }),
                        _hoisted_13,
                        _createVNode(_component_a_input, {
                          placeholder: "最高销量",
                          style: {"width":"144px"}
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, { label: "商品类型" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_checkbox_group, { options: _ctx.plainOptions }, null, 8, ["options"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"]),
        _createElementVNode("div", null, [
          _createVNode(_component_a_button, { style: {"margin-left":"10px"} }, {
            default: _withCtx(() => [
              _hoisted_14
            ]),
            _: 1
          }),
          _createVNode(_component_a_button, { style: {"margin-left":"10px"} }, {
            default: _withCtx(() => [
              _hoisted_15
            ]),
            _: 1
          }),
          _createVNode(_component_a_button, { style: {"margin-left":"10px"} }, {
            default: _withCtx(() => [
              _hoisted_16
            ]),
            _: 1
          }),
          _createVNode(_component_a_button, { style: {"margin-left":"10px"} }, {
            default: _withCtx(() => [
              _hoisted_17
            ]),
            _: 1
          }),
          _createVNode(_component_a_button, { style: {"margin-left":"10px"} }, {
            default: _withCtx(() => [
              _hoisted_18
            ]),
            _: 1
          }),
          _createVNode(_component_a_dropdown, null, {
            overlay: _withCtx(() => [
              _createVNode(_component_a_menu, { onClick: _ctx.handleMenuClick }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_menu_item, { key: "1" }, {
                    default: _withCtx(() => [
                      _hoisted_19
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_menu_item, { key: "2" }, {
                    default: _withCtx(() => [
                      _hoisted_20
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_menu_item, { key: "3" }, {
                    default: _withCtx(() => [
                      _hoisted_21
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_menu_item, { key: "3" }, {
                    default: _withCtx(() => [
                      _hoisted_22
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_menu_item, { key: "3" }, {
                    default: _withCtx(() => [
                      _hoisted_23
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            default: _withCtx(() => [
              _createVNode(_component_a_button, { style: {"margin-left":"10px"} }, {
                default: _withCtx(() => [
                  _hoisted_24,
                  _createVNode(_component_DownOutlined)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_a_table, {
      dataSource: _ctx.list,
      columns: _ctx.columns,
      loading: _ctx.loading,
      bordered: "",
      pagination: _ctx.pagination,
      "row-selection": _ctx.rowSelection,
      onChange: _ctx.handleTableChange,
      style: {"margin-top":"10px"}
    }, {
      bodyCell: _withCtx(({ column, text, record }) => [
        (column.key === 'action')
          ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
              _createVNode(_component_a_button, {
                size: "small",
                type: "danger",
                disabled: record.del == 1,
                onClick: ($event: any) => (_ctx.onDel(record))
              }, {
                default: _withCtx(() => [
                  _hoisted_26
                ]),
                _: 2
              }, 1032, ["disabled", "onClick"])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["dataSource", "columns", "loading", "pagination", "row-selection", "onChange"])
  ]))
}